import { Bar } from "@ant-design/plots";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { HomeCard } from "../../../../../components";

import { envChangeType } from "../../../../../plugins/utils";
import { useGetProductOverview } from "../../hooks/productreport.hook";
import styles from "./style.module.scss";

const DataChart = () => {
  const [maxWL, setMaxWL] = useState(10);
  const { data: productOverview } = useGetProductOverview({});
  const { t } = useTranslation();
  const data = [
    {
      type: "沙巴體育",
      values: [0, -40],
      sum_win_loss: -40,
    },
    {
      type: "區塊鏈彩票",
      values: [0, 108],
      sum_win_loss: 108,
    },
  ];

  useEffect(() => {
    if (productOverview) {
      if (productOverview?.data?.length <= 0) return;

      let max = 0;
      productOverview?.data?.forEach((d) => {
        const newMax = d.sum_win_loss > 0 ? d.sum_win_loss : d.sum_win_loss * -1;
        max = max < newMax ? newMax : max;
      });
      setMaxWL(max);
    }
  }, [productOverview]);

  const config = {
    data: productOverview?.data
      ? productOverview?.data?.map((d) => {
          return {
            ...d,
            type: `${t([
              `comission.platform.game.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${d.game_3th_code}`,
              `comission.platform.game.${d.game_3th_code}`,
            ])}`,
            values: [0, d.sum_win_loss],
          };
        })
      : [], //reverse(),
    xField: "values",
    yField: "type",
    color: (item) => {
      const currentGameItem = productOverview?.data?.find((g) => {
        const _type = `${t([
          `comission.platform.game.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${g.game_3th_code}`,
          `comission.platform.game.${g.game_3th_code}`,
        ])}`;
        return _type === item.type;
      });

      return currentGameItem?.sum_win_loss >= 0 ? "green" : "red";
      // return item?.values[1] >= 0 ? 'red' : 'green';
    },
    isRange: true,
    xAxis: {
      max: maxWL,
      min: maxWL * -1,
    },
    label: {
      position: "middle",
      content: (item) => {
        return item.values[1];
      },
      layout: [
        {
          type: "adjust-color",
        },
      ],
    },
    tooltip: {
      title: " ",
      formatter: (datum) => {
        return { name: datum.type, value: datum.values[1] };
      },
    },
  };
  return (
    <HomeCard title={t("mobile.productReport.chart.title")}>
      <div className={styles.bodyContainer}>
        <Bar {...config} style={{ width: "100%" }} />
      </div>
    </HomeCard>
  );
};

export default DataChart;
